module.exports = __webpack_public_path__ + "img/vfy.6f284509.png";